import { action, observable } from 'mobx';
import { HttpClient, setMap } from 'Mri.Web.Common';

export class ClientsStore {
    public constructor(httpClient: HttpClient) {
        this.httpClient = httpClient;
    }

    @action
    public async loadClientsAsync() {
        const clients = await this.httpClient.get<Mri.Web.Portal.Controllers.Clients.ClientModel[]>('/api/v1/clients');

        setMap(this.clients, clients, c => c.clientId);
    }

    @action
    public async addClientAsync(add: Mri.Web.Portal.Controllers.Clients.AddClientModel) {
        const model = await this.httpClient.post<Mri.Web.Portal.Controllers.Clients.AddedClientModel>(
            '/api/v1/clients',
            add
        );

        await this.loadClientsAsync();

        if (model) {
            this.clients.set(model.client.clientId, model.client);
            return model.clientSecret;
        }
    }

    @action
    public async removeClientAsync(client: Mri.Web.Portal.Controllers.Clients.ClientModel) {
        await this.httpClient.delete(`/api/v1/clients/${client.clientId}`);

        this.clients.delete(client.clientId);
    }

    @observable
    public clients = new Map<string, Mri.Web.Portal.Controllers.Clients.ClientModel>();

    private readonly httpClient: HttpClient;
}
